import { Action } from '@ngrx/store';
import { Season } from '@app/models/season';

export enum SeasonActionTypes {
  Load = '[API] Load Seasons',
  LoadSuccess = '[API] Load Seasons Success',
  LoadFail = '[API] Load Seasons Fail',
  Select = '[Season] Select'
}

export class Load implements Action {
  readonly type = SeasonActionTypes.Load;
  constructor() {}
}

export class LoadSuccess implements Action {
  readonly type = SeasonActionTypes.LoadSuccess;
  constructor(public seasons: Season[]) {}
}

export class LoadFail implements Action {
  readonly type = SeasonActionTypes.LoadFail;
  constructor(public error: any) {}
}

export class Select implements Action {
  readonly type = SeasonActionTypes.Select;
  constructor(public id: number) {}
}

export type SeasonActionsUnion = Load | LoadSuccess | LoadFail | Select;
